const normalizeSharedKits = (kits, productsObj = {}) => {
  const products = { ...productsObj };

  const normalizedKits = (kits || []).map((kit) => {
    const { items, ...restKitFields } = kit;

    return {
      ...restKitFields,
      products: (items || []).map((item) => {
        products[item.product.product_id] = item.product;
        return {
          product: item.product.product_id,
          nums: item.quantity,
          isOrderable: item.is_orderable,
        };
      }),
    };
  });

  return { kits: normalizedKits, products };
};

const normalizeSharedKit = (kit, productsObj = {}) => {
  const { kits, products } = normalizeSharedKits([kit], productsObj);

  return { kit: kits[0], products };
};

const canOrderSharedKit = (kit) => !!kit?.has_available_items;

const getNotOrderableKitProducts = (kit) =>
  (kit?.products || []).filter(({ isOrderable }) => !isOrderable);

export {
  normalizeSharedKits,
  normalizeSharedKit,
  canOrderSharedKit,
  getNotOrderableKitProducts,
};
